const delay = (callback, ms, timeoutRef) => {
  if (timeoutRef) {
    window.clearTimeout(timeoutRef); // eslint-disable-line no-undef
  }
  return window.setTimeout(callback, ms); // eslint-disable-line no-undef
};

export default delay;
